import {action, makeAutoObservable} from "mobx"

class DocsContentStore {
    private content: string = ""

    constructor() {
        makeAutoObservable(this)
    }

    getContent(): string {
        return this.content
    }

    @action
    setContent(content: string) {
        this.content = content
    }
}

export const docsContentStore: DocsContentStore = new DocsContentStore()
